import i18n from '../../i18n';

// Month names come from the common namespace at call time, so they follow the current language.
type MonthKey = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12';

export const monthName = (month: number) => i18n.t(`common:months.${String(month) as MonthKey}`);

const shortMonth = (month: number) => i18n.t(`common:monthsShort.${String(month) as MonthKey}`);

export const monthLabel = (year: number, month: number) =>
    i18n.t('accounting:closing.monthLabel', { month: monthName(month), year });

/** History caption for a reopened month or year: when, who and why. */
export const reopenedNote = (h: { reopenedAt?: string | null; reopenedBy?: string | null; reopenReason?: string | null }) => {
    const date = h.reopenedAt ? new Date(h.reopenedAt).toLocaleDateString() : null;
    const when = date && h.reopenedBy
        ? i18n.t('accounting:closing.dateBy', { date, name: h.reopenedBy })
        : h.reopenedBy ? i18n.t('accounting:closing.by', { name: h.reopenedBy }) : date;
    if (when && h.reopenReason) return i18n.t('accounting:closing.withReason', { when, reason: h.reopenReason });
    return when || h.reopenReason || '';
};

/** "2026-07-31" → "31 Jul 2026", without time-zone shifts. */
export const dayLabel = (iso: string) => {
    const [y, m, d] = iso.split('-').map(Number);
    return i18n.t('accounting:closing.dayLabel', { day: d, month: shortMonth(m), year: y });
};
